import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import type { ProducerInline } from "@/components/place/types";

interface PlaceProducerRow {
  place_id: string;
  producer_id: string;
  producer_slug: string;
  producer_name: string;
  producer_description: string | null;
  producer_avatar_url: string | null;
  is_verified: boolean;
  producer_features: string[] | null;
  updated_at: string;
}

export function usePlaceProducers(placeId?: string) {
  const query = useQuery({
    queryKey: ["place-producers", placeId],
    queryFn: async (): Promise<ProducerInline[]> => {
      if (!placeId) return [];

      const { data, error } = await supabase
        .rpc("get_place_producers_public" as any, {
          p_place_id: placeId,
          p_limit: 100,
        });

      if (error) {
        console.error("Error fetching place producers:", error);
        throw error;
      }

      return (data as unknown as PlaceProducerRow[])
        .sort((left, right) => left.producer_name.localeCompare(right.producer_name, "sv"))
        .map((row) => ({
        id: row.producer_id,
        slug: row.producer_slug,
        name: row.producer_name,
        shortDescription: row.producer_description ?? undefined,
        avatarUrl: row.producer_avatar_url ?? undefined,
        features: row.producer_features ?? [],
        isVerified: row.is_verified,
      }));
    },
    enabled: !!placeId,
  });

  return {
    producers: query.data ?? [],
    loading: query.isLoading,
    error: query.error?.message ?? null,
  };
}
